import { ConverterInput } from "./types";

export const apiDataToWatermarkPosition = (
  inputParams: ConverterInput,
  isDialog?: boolean
) => {
  const { chartId } = inputParams;
  if (chartId === "revenue-breakdown-chart") {
    return {
      left: isDialog ? 80 : 72,
      top: isDialog ? 100 : 125,
    };
  }

  return {
    left: isDialog ? 66 : 60,
    top: isDialog ? 90 : 100,
  };
};
